import { Component, Output, EventEmitter, Input } from '@angular/core';
import { Locale } from 'src/app/models/locale';
import { LocaleService } from 'src/app/services/locale.service';

@Component({
  selector: 'app-postal-code',
  templateUrl: './postal-code.component.html',
  styleUrls: ['./postal-code.component.css']
})
export class PostalCodeComponent {
  addresses:Locale[] = [];

  @Output() selected: EventEmitter<Locale>;
  
  @Input() zipCode: number;
  @Output() zipCodeChange: EventEmitter<number>;

  constructor(private serv:LocaleService) { 
    this.selected = new EventEmitter();
    this.zipCodeChange = new EventEmitter();
  }

  select(address:Locale) {
    this.selected.emit(address);
    this.addresses = [];
  }

  change() {
    this.zipCodeChange.emit(this.zipCode);
  }

  async search() {
    this.addresses = await this.serv.getByZipCode(this.zipCode);
  }
}
